export default __webpack_public_path__ + "static/media/four.1d7053f1.svg";